module.exports = __webpack_public_path__ + "img/H2.0129cf95.png";